/*
  «Последние обращения» на экране коммуникаций - страницами с сервера (21.10.2026,
  требование владельца: «пагинация должна быть серверной, а не на фронте»).

  Раньше экран просил у сервера «последние 50» одним ответом и резал их страницами в
  браузере: обращение за пределом выдачи было недоступно вовсе. Теперь страницу
  (`limit`, `offset`) отдаёт сервер вместе с общим числом, и до любого обращения можно
  долистать. `version` меняется после запуска обзвона или рассылки - текущая страница
  перечитывается, а номер страницы не сбрасывается.
*/

import { useCallback } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client.js'
import { dateTime } from '../api/format.js'
import { Empty, Loading, Notice, Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'
import usePagedList from './usePagedList.js'

export default function ContactHistory({ version }) {
  const load = useCallback((window) => api.contactHistory(window), [])
  const { rows, error, bar } = usePagedList(load, undefined, version)

  return (
    <div className="card">
      <div className="section__title">Последние обращения</div>
      <Notice error={error} />
      {rows === null && !error ? <Loading what="Загружаем обращения" /> : null}
      {rows !== null && rows.length === 0 ? (
        <Empty title="Обращений ещё не было">
          Здесь появятся звонки и сообщения - включая недозвоны. Для правила частоты
          недозвон такой же контакт: телефон звонил, человек его видел.
        </Empty>
      ) : null}
      {rows !== null && rows.length > 0 ? (
        <div className="log">
          {rows.map((contact) => (
            /* 🔴 Строка называет, КОМУ обращались, и чем это кончилось
               (решение владельца 25.09.2026). До этого она отвечала «звонок,
               разговор состоялся» - то есть ни на один из двух вопросов, с
               которыми список открывают. Ведёт она на страницу обращения:
               там разговор целиком, путь по шагам и судьба ссылки. */
            <div className="log__row" key={contact.id}>
              <span className="log__when">{dateTime(contact.occurred_at)}</span>
              <Link to={`/communications/${contact.id}`}>
                {contact.channel_title}
                {contact.account_number ? ` по счёту ${contact.account_number}` : ''}
              </Link>
              <span>
                {contact.debtor_name ? <span>{contact.debtor_name}</span> : null}
                {contact.phone ? <span className="muted"> · {contact.phone}</span> : null}
                <div className="log__states">
                  <span className="muted">{contact.outcome_title}</span>
                  {contact.states.map((state) => (
                    <Tag key={state.value} kind="calm">
                      {state.title}
                    </Tag>
                  ))}
                </div>
              </span>
            </div>
          ))}
        </div>
      ) : null}
      {/* Было «Показано N обращений» без страниц и с неверным склонением (осмотр
          08.09.2026); с 21.10.2026 - общая панель: число записей и страницы. */}
      <PageBar {...bar} what="обращений" />
    </div>
  )
}
